import { useTranslation } from 'react-i18next';
import { useTheme } from '../theme/ThemeProvider';
import { Button } from './ui/Button';

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const { t } = useTranslation();

  return (
    <Button variant="ghost" onClick={toggle} title={t('theme.toggle')} aria-label={t('theme.toggle')}>
      {theme === 'dark' ? '☀️' : '🌙'}
    </Button>
  );
}
